import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GeneralInfo from "../components/GroupInfo/GeneralInfo";
import GroupFilter from "../components/GroupInfo/GroupFilter";
import Pagination from "../components/GroupInfo/Pagination";
import QuestionAnswers from "../components/GroupInfo/QuestionAnswers";
import { archiveLeadDetails, getGroupInfo } from "../redux/actions/groupInfo";
import Loader from "../components/Loader";
import Toaster from "../components/Toaster";
import GroupSettings from "../components/GroupInfo/GroupSettings";
import { toast } from "react-toastify";
import Automation from "../components/GroupInfo/Automation/Automation";
import { getOverallMessageGroups } from "../redux/actions/messageGroupSettings";

const GroupInfo = () => {
  const [tab, setTab] = useState(1);
  const dispatch = useDispatch();

  const [curpage, setCurpage] = useState(1);
  const [groupFilter, setGroupFilter] = useState("");
  const [allMessageGroupList, setAllMessageGroupList] = useState([]);

  const leadList = useSelector((state) => state.leadList);
  const { loading, leads, page, totalPage, groups } = leadList;

  const messageGroupsSettings = useSelector(
    (state) => state.messageGroupsSettings
  );
  const { allMessageGroups } = messageGroupsSettings;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  useEffect(() => {
    dispatch(getOverallMessageGroups());
  }, []);

  useEffect(() => {
    if (allMessageGroups?.length > 0) {
      setAllMessageGroupList(allMessageGroups);
    }
  }, [allMessageGroups]);

  // const prevGrFilter = usePrevious(groupFilter);

  useEffect(() => {
    // if (prevGrFilter !== groupFilter) {
    //   setCurpage((pageNo) => 1);
    // }
    dispatch(getGroupInfo(curpage, groupFilter));
  }, [dispatch, curpage, groupFilter]);

  useEffect(() => {
    if (tab === 3 && !groupFilter) {
      window.location.reload();
    }
  }, [tab, groupFilter]);

  const archiveLead = (leadId) => {
    dispatch(archiveLeadDetails(leadId));
  };

  return (
    <>
      {loading && <Loader />}
      <GroupFilter
        groups={groups}
        setGroupFilter={setGroupFilter}
        groupFilter={groupFilter}
        setCurpage={setCurpage}
      />
      <div className="container customizeWrapers">
        <ul className="tabs">
          {/* <!-- Toggle the className current to display the respective tab contents --> */}
          <li
            data-tab="tab-1"
            className={tab === 1 ? "tab-link current" : "tab-link"}
            onClick={(e) => setTab((val) => 1)}
          >
            General Information
          </li>
          <li
            className={tab === 2 ? "tab-link current" : "tab-link"}
            data-tab="tab-2"
            onClick={(e) => setTab((val) => 2)}
          >
            Questions & Answers
          </li>
          <li
            className={tab === 3 ? "tab-link current" : "tab-link"}
            data-tab="tab-3"
            onClick={(e) => {
              if (!groupFilter) {
                toast.info(
                  "Please select a group from the drop down to view and edit the group settings"
                );
              } else {
                setTab((val) => 3);
              }
            }}
          >
            Group Settings
          </li>
          <li
            className={tab === 4 ? "tab-link current" : "tab-link"}
            data-tab="tab-4"
            onClick={(e) => setTab((val) => 4)}
          >
            Automation
          </li>
        </ul>

        {tab === 1 && <GeneralInfo leads={leads} archiveLead={archiveLead} />}
        {tab === 2 && (
          <QuestionAnswers leads={leads} archiveLead={archiveLead} />
        )}
        {tab === 3 && groupFilter && (
          <GroupSettings
            groupFilter={groupFilter}
            groups={groups}
            messageGroups={allMessageGroupList}
          />
        )}
        {tab === 4 && (
          <Automation
            groups={groups}
            groupFilter={groupFilter}
            messageGroups={allMessageGroupList}
          />
        )}
        {(tab === 1 || tab === 2) && (
          <Pagination
            setCurpage={setCurpage}
            totalPage={totalPage}
            page={page}
          />
        )}
      </div>
      <Toaster />
    </>
  );
};

// // Hook
// function usePrevious(value) {
//   const ref = useRef();
//   useEffect(() => {
//     ref.current = value;
//   }, [value]);
//   return ref.current;
// }
export default GroupInfo;
